import { Injectable } from '@angular/core';
import firebase from 'firebase';
import 'firebase/firestore';
import { Subscription } from 'rxjs/Subscription';
/*
  Generated class for the FbProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class FbProvider {
  btDriverDB: firebase.app.App;
  watchDriverPosition: any;
  constructor() {
    console.log('Hello FbProvider Provider');
    this.init();
  }
  init(){
      console.log('Init BTDriver firebase dabase.');
     var BTDriverConfig = {
      apiKey: "AIzaSyAwuFakmf8ammUgV0FCpVST-ZaJVmu3uuk",
      authDomain: "btdriver-e28c5.firebaseapp.com",
      databaseURL: "https://btdriver-e28c5.firebaseio.com",
      projectId: "btdriver-e28c5",
      storageBucket: "btdriver-e28c5.appspot.com",
      messagingSenderId: "536415229024"
    };
    console.log('Initialize firebase...');
    this.btDriverDB = firebase.initializeApp(BTDriverConfig,"secondary");
    
  }
  //Will implement these functions when we have a solution
  // getAllDriverPosition() {
  //   let db = this.btDriverDB.firestore();
  //   db.collection('users').get().then((querySnapshot) => {
  //     querySnapshot.forEach((doc) =>{
  //       console.log(doc.data());
  //     });
  //   });
  // }
  // startMonitor(){
  //   let db = this.btDriverDB.firestore();
  //   this.watchDriverPosition = db.collection('users')
  //     .onSnapshot((querySnapshot) => {
  //       let positions = [];
  //       querySnapshot.forEach((doc) => {
  //           positions.push(doc.data().geoPosition);
  //       });
  //       console.log('driverPosition', positions);
  //     });
  // }
  // stopMonitor() {
  //   this.watchDriverPosition();
  // }
}



// WEBPACK FOOTER //
// ./src/providers/fb/fb.ts